exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-title {\n    padding: 1rem 2rem 1rem 0;\n    border-bottom: 1px solid #83d54d;\n    border-radius: 5px;\n    font-size: 26px;\n}\n\n.section-description {\n    padding: 1.5rem 0;\n}\n\n.section-intro {\n    font-size: 1.6rem;\n    font-weight: 400;\n    text-align: center;\n    font-style: oblique;\n    padding: 1rem;\n}\n", ""]);

// exports
